import { Breadcrumb, Button, Col, Divider, Drawer, Dropdown, Flex, Form, Input, Layout, Popconfirm, Radio, Row, Select, Table, Tag, theme, Typography, message } from 'antd';
import { CopyOutlined, HomeOutlined, DeleteOutlined, MoreOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import Templates from '../../../helperComponents/Templates';
import { useSelector } from 'react-redux';
import { functions } from 'lodash';
import RequestTypeManagementAPI from '../../../restAPI/RequestTypeManagementAPI';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';

const { Header, Footer, Sider, Content } = Layout;
const { Search, TextArea } = Input;
const { Option } = Select;
const { Text } = Typography;

export default function RequestedTypeManager({ props }) {

    const { token: { colorBgContainer, borderRadiusLG, colorTextDescription }, } = theme.useToken();

    const [actionForm] = Form.useForm();

    const [openNewDrawer, setOpenNewDrawer] = useState(false);

    const { companyId, token, userId, userCompany } = useSelector(state => state.auth);

    const [approvalRequestList, setApprovalRequestList] = useState([]);
    const [actionButton, setActionButton] = useState(0);
    const [actionButtonName, setActionButtonName] = useState();
    const [objectData, setObjectData] = useState();
    const [disableInputField, setDisableInputField] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [refreshUseState, setRefreshUseState] = useState();
    const [isLoadingRequestTypes, setIsLoadingRequestTypes] = useState(false);

    useEffect(() => {
        setIsLoadingRequestTypes(true);
        getRequestTypesList()
    }, [companyId]);

    useEffect(() => {
        getRequestTypesList()
    }, [refreshUseState]);

    const showNewDrawer = () => {
        setOpenNewDrawer(true);
    };

    const closeNewDrawer = () => {
        setOpenNewDrawer(false);
        setDisableInputField(false)
    };

    const columns = [
        {
            title: 'Request Type',
            dataIndex: 'requestType',
            key: 'requestType',
        },
        {
            title: 'Action Date',
            dataIndex: 'actionDate',
            key: 'actionDate',
        },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            align: 'center',
            render: (text, record) => (
                <Flex gap={16}>
                    <Button onClick={() => onClickEditButton(record)} icon={<EditOutlined />} />
                    <Button onClick={() => onClickDeleteButton(record)} icon={<DeleteOutlined />} />
                </Flex>
            ),
        },
    ];


    async function getRequestTypesList() {
        await RequestTypeManagementAPI.getRequestTypeList(companyId, token).then((res) => {
            for(var item of res.data){
                item['createdAt'] = new Date(item['createdAt']).toLocaleString()
                item['updatedAt'] = new Date(item['updatedAt']).toLocaleString()

                if(item['createdAt'] == item['updatedAt']){
                    item['actionDate'] = ('C - ' + item['createdAt'])
                }else{
                    item['actionDate'] = ('U - ' + item['updatedAt'])
                }
            }
            setApprovalRequestList(res.data)
            setIsLoadingRequestTypes(false)
            return res.data;
        }).catch((error) => {
            setIsLoadingRequestTypes(false);
        })
    }

    const onFinish = async (values) => {
        setRefreshUseState(true)
        setIsLoadingRequestTypes(true);
        //console.log('Success:', values);
        var formData = { requestType: values.requestType }
        if (actionButton == 1) {
            
            try {
                await RequestTypeManagementAPI.createRequestType(companyId, token, formData).then((res) => {
                    messageApi.open({
                        type: 'success',
                        content: 'Successfully Created',
                      });
                })
            } catch (error) {
                messageApi.open({
                    type: 'error',
                    content: error.response.data.message,
                  });
            }
        }else if(actionButton == 2){
            try {
                await RequestTypeManagementAPI.updateRequestType(companyId, token, values._id, formData).then((res) => {
                    messageApi.open({
                        type: 'success',
                        content: 'Successfully Updated',
                      });
                })
            } catch (error) {
                messageApi.open({
                    type: 'error',
                    content: error.response.data,
                  });
            }
        }else if(actionButton == 3){
            try {
                await RequestTypeManagementAPI.deleteRequestType(companyId, token, values._id).then((res) => {
                    messageApi.open({
                        type: 'success',
                        content: 'Successfully Deleted',
                      });
                })
            } catch (error) {
                console.log(error)
                messageApi.open({
                    type: 'error',
                    content: error.response.data,
                  });
            }
        }
        setRefreshUseState(false)
        closeNewDrawer()
    };

    function onClickCreateNewButton(){
        actionForm.resetFields()
        setActionButton(1)
        setActionButtonName('Save')
        showNewDrawer()
    }

    function onClickEditButton(record){
        actionForm.setFieldsValue({
            _id: record._id,
            requestType: record.requestType
        })
        
        setActionButton(2)
        setActionButtonName('Edit')
        showNewDrawer()
        setObjectData(record)
    }

    function onClickDeleteButton(record){
        actionForm.setFieldsValue({
            _id: record._id,
            requestType: record.requestType
        })
        setDisableInputField(true)

        setActionButton(3)
        setActionButtonName('Delete')
        showNewDrawer()
        setObjectData(record)
        //setDisableInputField(true)
    }

    return (
        <>
        {contextHolder}
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Request Type Manager',
                        },
                    ]}
                />

                <Flex justify='center' align='center' gap={48}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => onClickCreateNewButton()} >Create New</Button>
                </Flex>

            </Flex>

            <div style={{
                margin: '16px',
                // padding: 24,
                minHeight: "78svh",

                borderRadius: borderRadiusLG,
            }}>
                {isLoadingRequestTypes ? (<>
                    <CommonSkeletonLoader itemCount={3} />
                </>) : (<>
                    <Table columns={columns} dataSource={approvalRequestList} />
                </>)}

                <Drawer
                    title="Request Type"
                    onClose={closeNewDrawer}
                    open={openNewDrawer}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={closeNewDrawer}>
                                Cancel
                            </Button>

                            <Button
                                //onClick={closeNewDrawer}
                                onClick={() => actionForm.submit()}
                                type="primary"
                            >
                                {actionButtonName}
                            </Button>
                        </Flex>
                    ]
                    }
                >
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        form={actionForm}
                    >
                        <Form.Item
                            name="_id"
                            hidden={true}
                        >
                        </Form.Item>

                        <Form.Item
                            label="Type"
                            name="requestType"
                            rules={[{ required: true, message: 'Please input the type!' }]}
                        >
                            <Input disabled={disableInputField} placeholder="Enter type"/>
                        </Form.Item>
                    </Form>
                </Drawer>
            </div>
        </>
    )
}